import React from 'react';

import {
  Card,
  Dialog,
  DialogContent,
} from '@mui/material';

import CardMediaImage from '../CardMediaImage';

/**
 * プロパティ
 */
export type Props = {
  /** 施設ID */
  nurseryId: string,
  /** S3パス */
  s3Path: string,
  /** データURL */
  dataUrl?: string | undefined,
  /** 閉じる */
  close: () => void,
}

const PhotoModal: React.FC<Props> = ({
  nurseryId,
  s3Path,
  dataUrl,
  close,
}) => (
  <Dialog
    open
    onClose={close}
    onClick={close}
  >
    <DialogContent>
      <Card>
        <CardMediaImage
          s3Path={s3Path}
          onClick={close}
          alt="preview"
          objectFit="scale-down"
          nurseryId={nurseryId}
          dataUrl={dataUrl}
        />
      </Card>
    </DialogContent>
  </Dialog>
);

export default PhotoModal;
